import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./ConsciousBusiness.css";
import AccordionComponent from "../../Components/Accordion/AccordionComponent";
import Loading from "../../Components/Loading/Loading";

function ConsciousBusiness() {
  const [business, setBusiness] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isFetchedBusiness = useRef(false); // ✅ Prevents duplicate API call

  useEffect(() => {
    if (!isFetchedBusiness.current) {
      fetchBusiness();
      isFetchedBusiness.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const fetchBusiness = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}api/Business_services`
      );
      setBusiness(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <Loading />;
  if (error) return <p>Error: {error}</p>;
  return (
    <div className="ConsciousBusiness-container">
      <div className="ConsciousBusiness-pagetitle">
        <h1 className="firstpart">ONENESS</h1>
        <h1 className="secondpart">BY</h1>
        <h1 className="thirdpart">CACHOEIRA</h1>
      </div>
      <div className="ConsciousBusiness-secondpagetitle">
        <p className="firstpart">A CONSCIOUS</p>
        <p className="secondpart">BUSINESS MODALITY</p>
      </div>
      <div className="business-content-container">
        <p className="firstpart">
          The past decade’s rapid changes have made one thing clear: business
          survival demands more than just agility. Organizations of all sizes
          have had to fundamentally reimagine their approach to stay relevant -
          from how they communicate and market themselves to how they engage
          with their stakeholders. This evolution has given rise to new economic
          models - shared, creative, circular, green, and purple economies - all
          reflecting changing market demands and stakeholder expectations. As
          businesses adapt, many have gone beyond updating strategies to explore
          their fundamental purpose, following Simon Sinek’s Golden Circle
          concept of starting with “WHY.” Apple exemplifies this approach:
          consumers choose their products not because they’re technically
          superior, but because they connect with the brand’s philosophy to
          “think different.”
        </p>
        <p className="secondpart">
          We propose taking this journey even further. In today’s digital age,
          authentic differentiation and community building have become crucial
          differentiators. Our focus is on helping businesses transform through
          genuine human connection - not out of nostalgia, but because
          vulnerability, authenticity, and adaptability are uniquely human
          traits that create timeless brand narratives. With three decades of
          market experience, we understand that conscious business isn’t just a
          trend - it’s the future of sustainable enterprise.
        </p>
      </div>
      <div className="accordion-title-business">
        OUR CONSCIOUS BUSINESS SERVICES
      </div>
      <div className="accordion-container business-accordion">
        <AccordionComponent items={business} isbusiness={true} />
      </div>

      <div className="business-footer-content">
        <p>
          It is inevitable that businesses are destined to become conscious
          <br />
          or they won’t stand the test of change!
        </p>
        <p className="middle-title">
          Ready to begin your conscious
          <br />
          Business journey?
        </p>
        <p>
          Get in touch with us to explore ways to transform your organization,
          <br />
          into a purpose-driven brand that resonates authentically with your
          <br />
          stakeholders.
        </p>
      </div>
    </div>
  );
}

export default ConsciousBusiness;
